import { render, staticRenderFns } from "./MiraPartsLegend.vue?vue&type=template&id=4009ce64&scoped=true&"
import script from "./MiraPartsLegend.vue?vue&type=script&lang=ts&"
export * from "./MiraPartsLegend.vue?vue&type=script&lang=ts&"
import style0 from "./MiraPartsLegend.vue?vue&type=style&index=0&id=4009ce64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4009ce64",
  null
  
)

export default component.exports